import React from 'react'
import { useSelector, useDispatch } from 'react-redux'
import { StoreState } from '../../store'

import LinearProgress from '@material-ui/core/LinearProgress'
import List from '@material-ui/core/List'
import ListItem from '@material-ui/core/ListItem'
import Typography from '@material-ui/core/Typography'
import Box from '@material-ui/core/Box'

import ArrowDownwardIcon from '@material-ui/icons/ArrowDownward'
import ArrowUpwardIcon from '@material-ui/icons/ArrowUpward'

import { editingStart } from '../../store/categories/categoriesActions'

export default function CategoriesList() {
  const { categories, selectedIndex, isEditing, isLoading } = useSelector(
    ({ categoriesState }: StoreState) => {
      return {
        categories: categoriesState.categories,
        selectedIndex: categoriesState.selectedIndex,
        isEditing: categoriesState.isEditing,
        isLoading: categoriesState.loadingCategories,
      }
    }
  )

  const dispatch = useDispatch()
  const onClickItem = (index: number) => () => {
    dispatch(editingStart(index))
  }

  if (isLoading) {
    return <LinearProgress />
  }

  return (
    <List>
      {!categories.length ? (
        <Box display="flex" justifyContent="center" color="gray" marginTop={1}>
          <Typography
            variant="caption"
            align="center"
            children="Nenhum registro encontrado"
          />
        </Box>
      ) : (
        categories.map((category, i) => (
          <List key={i}>
            <ListItem
              button
              onClick={onClickItem(i)}
              selected={isEditing && selectedIndex === i}
            >
              <Box display="flex" flex={1} justifyContent="space-between">
                <Box>
                  <Typography>
                    {category.name}
                    {!category.active && ' (inativo)'}
                  </Typography>

                  {category.type === 'incomes' ? (
                    <ArrowUpwardIcon
                      style={{ color: '#00B9F2', fontSize: 18 }}
                    />
                  ) : (
                    <ArrowDownwardIcon
                      style={{ color: '#ff0000', fontSize: 18 }}
                    />
                  )}
                  <Typography
                    variant="caption"
                    children={
                      category.type === 'incomes' ? 'Receitas' : 'Despesas'
                    }
                  />
                </Box>
              </Box>
            </ListItem>
            <hr className="ml-4" />
          </List>
        ))
      )}
    </List>
  )
}
